import { useQuery } from '@tanstack/react-query';
import { OLD_QBG } from 'src/constants/constants';
import {
  getAdminVideoUrlDetailsFetcher,
  getVideoUrlDetailsFetcher,
} from 'src/lib/fetchers/video-player-fetcher';
import { selectPlayerParams, useSelector } from 'src/lib/redux';
import { isOTT } from 'src/lib/utilities';
import { logger } from 'src/services/logger/loggerService';
import { isPPAdmin } from 'src/services/utils';
import { getQueryParams } from 'src/usePlayerParams';

type videoUrlDetails = {
  url: string;
  urlType: string;
};

type Props = {
  videoUrlDetails: videoUrlDetails | any;
  isLoading: boolean;
  error: any;
  videoUrlDetailsRefetching: () => Promise<any>;
  videoUrlDetailsFetchingStatus: boolean;
};

const useVideoUrlDetails = ({
  type,
  childId,
  parentId,
  secondaryChildId,
  secondaryParentId,
  videoId,
  videoUrl,
  disableCMAF,
  videoContainerType,
  metadata,
  isFromCjr,
  enabled = false,
}: {
  type?: string;
  childId?: string;
  parentId?: string;
  secondaryChildId?: string;
  secondaryParentId?: string;
  videoId?: string;
  videoUrl?: string;
  disableCMAF?: boolean;
  videoContainerType?: string;
  metadata?: string;
  isFromCjr?: boolean;
  enabled?: boolean;
}): Props => {
  const { vType } = getQueryParams();
  const { skillsToken } = useSelector(selectPlayerParams);

  const { data, isLoading, error, refetch, isFetching } = useQuery(
    [
      `video-url-details-${type}-${childId}-${parentId}-${secondaryParentId}-${secondaryChildId}-${skillsToken}-${videoId}-${metadata}`,
      {
        type,
        childId,
        parentId,
        secondaryChildId,
        secondaryParentId,
        videoId,
        videoUrl,
        disableCMAF,
        skillsToken,
        videoContainerType,
        metadata,
        isFromCjr,
      },
    ],
    isPPAdmin() || vType === OLD_QBG ? getAdminVideoUrlDetailsFetcher : getVideoUrlDetailsFetcher,
    {
      enabled: !!enabled,
      retry: false,
      refetchOnWindowFocus: false,
      onError: (error: any) => {
        logger.error('Error fetching video URL detail:', error?.status, error);
        console.log('frwekifnrewuhferwfwe', error);

        // Redirect to subscription page if 403 error for OTT videos
        // Check both error.status and error response status
        const errorStatus = error?.status || error?.response?.status;
        if ((errorStatus === 403 || error === 'Forbidden') && isOTT()) {
          window.location.href = '/study-v2/pi/subscription';
        }
      },
    },
  );

  return {
    videoUrlDetails: data?.data,
    isLoading,
    error,
    videoUrlDetailsRefetching: refetch,
    videoUrlDetailsFetchingStatus: isFetching,
  };
};

export type drmDetailsType = {
  licenseUrl: string;
  licenseToken: string;
  drmVendor: string;
  drmType?: string;
  licenseDuration?: number;
  playingSource?: string;
};

export type videoUrlDetailsType = {
  url: string;
  signedUrl: string;
  urlType: string;
  drmDetails?: drmDetailsType;
  serverTime: number;
};

export default useVideoUrlDetails;
